import React, { useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PlayerSearchResults from '../playerSearchResults/PlayerSearchResults';
import useClickOutside from '../../clickOutside';

const FriendRequestsDropdown = ({
  friendRequests = 0,
  friendRequestPlayers = [],
  onPlayerClick,
  onClose,
  dropdownClassName = 'legacyFriendRequestPlayersDropdown',
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  //   console.log('FriendRequestsDropdown rendered with:', friendRequests);
  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleToggle = () => {
    // Only open dropdown if there are friend requests
    if (friendRequests > 0) setShowDropdown((prev) => !prev);
  };

  return (
    <li style={{ position: 'relative' }}>
      <div
        className="drawer-link-btn drawer-friend-requests"
        onClick={handleToggle}
        tabIndex={0}
        aria-label="Friend Requests"
        style={{
          cursor: friendRequests > 0 ? 'pointer' : 'not-allowed',
          opacity: friendRequests > 0 ? 1 : 0.6,
        }}
      >
        <Tooltip title="Friend Requests">
          <span className="drawer-link-icon">
            <PersonIcon style={{ marginRight: 8 }} />
          </span>
        </Tooltip>
        <span className="drawer-link-label">Friend Requests</span>
        {friendRequests > 0 && (
          <span className="pulse-badge" style={{ marginLeft: 8 }}>
            {friendRequests}
          </span>
        )}
      </div>
      {showDropdown && friendRequests > 0 && (
        <div ref={dropdownRef} className={dropdownClassName}>
          <PlayerSearchResults
            searchedPlayers={friendRequestPlayers}
            onPlayerClick={(playerObj) => {
              setShowDropdown(false);
              if (onPlayerClick) onPlayerClick(playerObj);
              if (onClose) onClose();
            }}
          />
        </div>
      )}
    </li>
  );
};

export default FriendRequestsDropdown;
